module.exports = __webpack_public_path__ + "img/alfaaz.bd030347.jpg";